var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActivites = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    fill: "none",
    viewBox: "0 0 16 11",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.785 1.179H.593A.585.585 0 0 1 0 .589C0 .26.26 0 .593 0h2.192c.332 0 .593.26.593.59s-.261.589-.593.589M2.785 4.456H.593A.585.585 0 0 1 0 3.866c0-.33.26-.589.593-.589h2.192c.332 0 .593.26.593.59s-.261.59-.593.59M2.785 7.735H.593A.585.585 0 0 1 0 7.145c0-.33.26-.59.593-.59h2.192c.332 0 .593.26.593.59s-.261.59-.593.59M2.785 11H.593A.585.585 0 0 1 0 10.41c0-.33.26-.589.593-.589h2.192c.332 0 .593.26.593.59s-.261.59-.593.59M15.407 1.179H5.534a.585.585 0 0 1-.593-.59c0-.33.261-.589.593-.589h9.873c.331 0 .592.26.592.59s-.26.589-.592.589M15.407 4.456H5.534a.585.585 0 0 1-.593-.59c0-.33.261-.589.593-.589h9.873c.331 0 .592.26.592.59s-.26.59-.592.59M15.407 7.735H5.534a.585.585 0 0 1-.593-.59c0-.33.261-.59.593-.59h9.873c.331 0 .592.26.592.59s-.26.59-.592.59M15.407 11H5.534a.585.585 0 0 1-.593-.59c0-.33.261-.589.593-.589h9.873c.331 0 .592.26.592.59s-.26.59-.592.59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v11H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActivites);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Activites.d93d6519094decdabc18f67b88086b4d.svg";